var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"tw-flex tw-justify-center tw-items-center"},[_c('span',[_vm._v(_vm._s(_vm.header))]),(_vm.count > 0)?_c('CountLabel',{attrs:{"count":_vm.count}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }